/**
 * @file environment.ts
 * @description Environment-related utility functions
 */

export const isDevOrTest = process.env.REACT_APP_ENV !== "production";
export const isDev = process.env.REACT_APP_ENV === "development";
export const isTest = process.env.REACT_APP_ENV === "test";
export const isProd = process.env.REACT_APP_ENV === "production";
